import { render } from "./vCarousel.vue?vue&type=template&id=2be36b9f&scoped=true"
import script from "./vCarousel.vue?vue&type=script&lang=js"
export * from "./vCarousel.vue?vue&type=script&lang=js"

import "./vCarousel.vue?vue&type=style&index=0&id=2be36b9f&lang=scss&scoped=true"

import exportComponent from "C:\\wamp64\\www\\artware\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be36b9f"]])

export default __exports__